function ServiceMap() {
  return (
    <svg
      className="globe"
      viewBox="0 0 1000 560"
      role="img"
      aria-labelledby="service-map-title service-map-description"
    >
      <title id="service-map-title">Ark Solutions international service map</title>
      <desc id="service-map-description">
        An accurate projected world map showing Cape Town, South Africa connected
        to the United States, United Kingdom, Ireland, the Netherlands and
        Australia.
      </desc>
      <image
        className="map-image"
        href="/assets/ark-solutions-world-map.svg"
        x="0"
        y="0"
        width="1000"
        height="500"
      />

      <g aria-hidden="true">
        <path className="route-halo" d="M549 373Q390 202 237 154" />
        <path className="route-halo" d="M549 373Q458 226 491 111" />
        <path className="route-halo" d="M549 373Q425 231 479 114" />
        <path className="route-halo" d="M549 373Q526 230 514 117" />
        <path className="route-halo" d="M549 373Q730 407 857 346" />
        <path
          className="route-line route-line--dash"
          d="M549 373Q390 202 237 154"
        />
        <path className="route-line" d="M549 373Q458 226 491 111" />
        <path className="route-line" d="M549 373Q425 231 479 114" />
        <path className="route-line" d="M549 373Q526 230 514 117" />
        <path className="route-line" d="M549 373Q730 407 857 346" />

        <line className="callout" x1="237" y1="154" x2="205" y2="132" />
        <line className="callout" x1="491" y1="111" x2="474" y2="73" />
        <line className="callout" x1="479" y1="114" x2="444" y2="105" />
        <line className="callout" x1="514" y1="117" x2="545" y2="101" />
        <line className="callout" x1="857" y1="346" x2="878" y2="325" />

        <circle className="node" cx="237" cy="154" r="7" />
        <circle className="node" cx="491" cy="111" r="7" />
        <circle className="node" cx="479" cy="114" r="7" />
        <circle className="node" cx="514" cy="117" r="7" />
        <circle className="node" cx="857" cy="346" r="7" />
        <circle className="origin" cx="549" cy="373" r="11" />

        <text x="104" y="126">
          United States
        </text>
        <text x="412" y="62">
          United Kingdom
        </text>
        <text x="374" y="103">
          Ireland
        </text>
        <text x="552" y="98">
          Netherlands
        </text>
        <text x="884" y="322">
          Australia
        </text>
        <text className="origin-label" x="568" y="404">
          Cape Town
        </text>
        <text className="map-note" x="500" y="536" textAnchor="middle">
          South African talent · global opportunity
        </text>
      </g>
    </svg>
  )
}

export function SouthAfrica() {
  return (
    <section
      className="section"
      id="why-south-africa"
      aria-labelledby="south-africa-title"
    >
      <div className="container sa-layout">
        <div className="reveal">
          <p className="section-number">05 / Why South Africa</p>
          <h2 className="section-title" id="south-africa-title">
            South African training. International potential.
          </h2>
          <p className="section-copy">
            South Africa offers strong professional accounting education,
            English-language business communication, IFRS experience,
            international audit exposure, compatibility with remote professional
            work and competitive economics.
          </p>
          <p className="framework-note">
            Strong IFRS grounding, with client-specific accounting framework
            training where needed.
          </p>
        </div>
        <div className="globe-wrap reveal">
          <ServiceMap />
        </div>
      </div>
    </section>
  )
}
